










































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import FormInput from '@/components/FormInput.vue'
import {replaceCommas} from '@/util/number.util';

const Erdensetzung = 1.15;

@Component({
  components: {
    FormInput
  }
})
export default class CustomForm extends Vue {
  @Prop() public value!: string;
  @Prop() public error!: string;

  public volumeInput = '1';
  public surfaceInput = '1';
  public heightInput = '20';

  public amountTypes = ['Volumen', 'Schütthöhe'];
  public amountDecision: string;

  public constructor() {
    super();
    this.amountDecision = this.amountTypes[0];
  }

  @Watch('amountDecision')
  public onChange() {
    if (this.amountDecision === 'Volumen') {
      this.$emit('input', this.volumeInput);
    } else {
      this.$emit('input', '' +
        parseFloat(replaceCommas(this.heightInput)) * parseFloat(replaceCommas(this.surfaceInput)) / 100 * Erdensetzung);
    }
  }
}
